module.exports = __webpack_public_path__ + "img/safe2.528cf62b.png";